/** @jsx jsx */
// Dependencies
import React, { FC } from 'react';
import { jsx, Container, Styled, Flex } from 'theme-ui';
import { graphql } from 'gatsby';

// Components
import Layout from '../components/Layout/Layout';
import Card from '../components/Card';
import { Query } from '../../graphql-types';
import getUrl from '../shared/getUrl';
import SEO from '../components/SEO';
import Article from '../components/Article';

// Query
export const pageQuery = graphql`
  query PostsQuery {
    allSanityPost {
      nodes {
        ...sanityPost
      }
    }
  }
`;

// Props
interface PostPageProps {
  data: Pick<Query, 'allSanityPost'>;
  styles?: {
    container: Object;
    content: Object;
    title: Object;
  };
}

// Components
const PostPage: FC<PostPageProps> = ({ data, styles }) => {
  const {
    allSanityPost: { nodes: sanityPosts },
  } = data;
  return (
    <Layout>
      <SEO />
      <Container sx={styles.container}>
        <Flex sx={styles.content}>
          {sanityPosts &&
            sanityPosts.map((post) => <Article post={post} key={post.id} />)}
        </Flex>
      </Container>
    </Layout>
  );
};

// Export
export default PostPage;

PostPage.defaultProps = {
  styles: {
    container: {
      position: 'relative',
      p: 2,
    },
    content: {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    title: {
      textAlign: 'center',
    },
  },
};
